import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {

  constructor() { }

  // Moving current language around
  private languageSource = new BehaviorSubject<string>(localStorage.getItem('lang') != null ? localStorage.getItem('lang') : 'el')
  currentLanguage = this.languageSource.asObservable()
  changeLanguageService(lang: string) {
    localStorage.setItem('lang', lang)
    this.languageSource.next(lang)
  }
}
